export enum EnvMode {
    Production = 'production',
    Stage = 'stage',
    Dev = 'dev',
}
